module.exports = __webpack_public_path__ + "img/hm-services.0482df23.png";